// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container-pPsR2Q{flex-direction:column;display:flex}.popup-container-id-CJBPL5{position:relative}.popup-container-id-CJBPL5 .semi-portal-inner{width:100%;top:2px!important;left:0!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popup-container": `popup-container-pPsR2Q`,
	"popupContainer": `popup-container-pPsR2Q`,
	"popup-container-id": `popup-container-id-CJBPL5`,
	"popupContainerId": `popup-container-id-CJBPL5`
};
export default ___CSS_LOADER_EXPORT___;
